
import { i18nText } from '@/locales';

import { FormModel, Select, Col, Row } from "ant-design-vue";

import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import { mixins } from "vue-class-component";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import { SimpleProxyForm } from "@/UI/components/Helpers/SimpleProxyForm";
import { PaginationMix } from "@/UI/mixins/PaginationMix";
import { ProductsTableMix } from "@/UI/mixins/Store/ProductsTableMix";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
//import createProduct from "@/form/Warehouse/Products/createProduct"
import { ProductsStore } from "@/store/modules/Warehouse/Products";
import { ProductsMix } from "@/UI/mixins/Store/ProductsMix";
import { ProductsCategoriesMix } from "@/UI/mixins/Store/ProductsCategoriesMix";
import { ProductsTaxMix } from "@/UI/mixins/Store/ProductsTaxMix";
import { ProductsTaxSystemMix } from "@/UI/mixins/Store/ProductsTaxSystemMix";
import { ProductsUnitMix } from "@/UI/mixins/Store/ProductsUnitMix";

import { ProductsCategoriesStore } from "@/store/modules/Warehouse/ProductsCategories";
import { ProductsUnitStore } from "@/store/modules/Warehouse/ProductsUnit";
import { ProductsTaxStore } from "@/store/modules/Warehouse/Tax";
import { ProductsTaxSystemStore } from "@/store/modules/Warehouse/TaxSystem";

import { ProductFormData, FormRules } from "@/form/Warehouse/Products/Product";
import { AppStateStore } from "@/store/modules/appState";
import { showNotification } from "@/UI/lib/messages";
import { RouterNameEnum } from "@/router/router.types";
import { getStudioId } from "@/UI/lib/state";

@Component({
    components: {
        PageTitle,
        FormGroup,
        BaseDataForm,
        "a-select": Select,
        "a-select-option": Select.Option,
        "a-col": Col,
        "a-row": Row,
        "a-form-model": FormModel,
        "a-form-model-item": FormModel.Item,
    },
})
export default class CreateProductForm extends mixins(
    SimpleProxyForm,
    PaginationMix,
    ProductsTableMix,
    ProductsMix,
    ProductsCategoriesMix,
    ProductsTaxMix,
    ProductsTaxSystemMix,
    ProductsUnitMix,
) {
    //@Prop() readonly form!: ProductFormData;
    @Prop() readonly mode!: number;
    form = new ProductFormData(parseInt(this.$route.params.Studio), parseInt(this.$route.params.Store));
    // rules = FormRules;
    saving = false;
    rules_validation: any = { required: true, message: i18nText("Пожалуйста укажите цену продажи"), trigger: 'change' }

    onInputNumber(number: Event) {
        const target = number.target as HTMLInputElement;
        console.log('onInputNi', target);

        if (target && target.value.startsWith('0')) {
            target.value = target.value.substring(1);
        }

        console.log('onInputNo', target.value);
    }

    get rules() {
        return { ...FormRules, selling_price: [this.rules_validation, { min: 1, message: i18nText("Поле должно быть больше 0"), trigger: 'change', type: 'number' }] }
    }

    @Watch("$store.state.appState.sendCancel", { deep: true })
    buttonCancel(value: boolean) {
        if (!value) return;
        Vue.router.push({
            name: RouterNameEnum.ListedProducts,
            params: { Studio: String(this.form.salon_id || getStudioId(this)), idCategory: String(this.form.category_id || 0) },
        });
        AppStateStore.setCancel(false)
    }

    // @Watch("$store.state.appState.sendSubmit", { immediate: true })
    async ButtonSubmit(): Promise<void> {
        if (this.saving) return;
        this.form.selling_price = Number(this.form.selling_price);
        this.form.sale_unit_value = Number(this.form.sale_unit_value);
        (this.$refs.productsForm as FormModel).validate(async valid => {
            if (!valid || this.saving) return;
            this.saving = true;
            try {
                const response = this.mode === 0 ? await ProductsStore.create(this.form) : await ProductsStore.update(this.form);
                showNotification(i18nText("Товар"), response);
                if (response.status) {
                    await this.$router.push({name: RouterNameEnum.ListedProducts,
                        params: {Studio: String(this.form.salon_id), idCategory: String(this.form.category_id || 0)}});
                }
            } catch (error) {
                this.$message.error(error.response?.data?.response || error.response?.data?.message || error.message);
            } finally {
                this.saving = false;
            }
        });
    }

    constructor() {
        super();
    }
    async created(): Promise<void> {
        try {
            if (this.mode === 1) {
                await ProductsStore.fetchData({filter: {id: Number(this.$route.params.id)}});
                if (this.product) this.form = (this.product as any).data[0];
            } else {
                this.form.salon_id = Number(getStudioId(this));
                this.form.category_id = Number(this.$route.params.fromCategory) || null;
            }
            await this.getCategories(Number(this.form.salon_id));
            await ProductsTaxStore.fetchAll();
            await ProductsTaxSystemStore.fetchAll();
            await ProductsUnitStore.fetchAll();
            this.formReady = true;
            this.tableLoad = true;
        } catch (e) {
            console.log("Error parse data -" + e);
        } finally {
            ///AppStateStore.setSubmit(false);
        }
    }
}
